// import {changeMapTocState} from '../../components/Map/MapActions';
import store from '../../store/store';

export const Authenticated = 'Authenticated';
export const NotAuthenticated = 'NotAuthenticated';
export const UserAccsessList = 'UserAccsessList';


export function setAuth(command){
    if(command){
            store.dispatch({type: Authenticated})

    }else{
            store.dispatch({type: NotAuthenticated})
        // changeMapTocState(props, false)
    }
}

export function setAccessList(list){
    store.dispatch({type: UserAccsessList, data: list})
}
